<div class="dashboard-container" dir="rtl">
  <!-- ===== STATS CARDS ===== -->
  <div class="stats-grid">
    <div class="stat-card total">
      <div class="stat-number">{{ stats.total }}</div>
      <div class="stat-label">
        <i class="fa fa-server stat-icon"></i> کل دیزل‌ها
      </div>
    </div>
    <div class="stat-card online">
      <div class="stat-number">{{ stats.online }}</div>
      <div class="stat-label">
        <i class="fa fa-circle stat-icon text-success"></i> آنلاین
      </div>
    </div>
    <div class="stat-card offline">
      <div class="stat-number">{{ stats.offline }}</div>
      <div class="stat-label">
        <i class="fa fa-circle stat-icon text-danger"></i> آفلاین
      </div>
    </div>
    <div class="stat-card starting">
      <div class="stat-number">{{ stats.starting }}</div>
      <div class="stat-label">
        <i class="fa fa-circle stat-icon text-warning"></i> در حال استارت
      </div>
    </div>
    <div class="stat-card error">
      <div class="stat-number">{{ stats.error }}</div>
      <div class="stat-label">
        <i class="fa fa-exclamation-triangle stat-icon text-danger"></i> خطا
      </div>
    </div>
  </div>

  <!-- ===== MAP ===== -->
  <div class="map-row mb-4">
    <div class="custom-card p-3">
      <div
        class="map-header d-flex justify-content-between align-items-center mb-3"
      >
        <h3 class="m-0 fs-6">
          <i class="fa fa-map-marker text-info me-2"></i> موقعیت دیزل‌ها روی
          نقشه
        </h3>
        <div class="map-legend d-flex gap-3">
          <span><span class="dot dot-green"></span> آنلاین</span>
          <span><span class="dot dot-yellow"></span> استارت</span>
          <span><span class="dot dot-orange"></span> خطا</span>
          <span><span class="dot dot-red"></span> آفلاین</span>
          <span><span class="dot dot-gray"></span> نامشخص</span>
        </div>
      </div>
      <div id="fleet-map"></div>
    </div>
  </div>

  <!-- ===== TABLE ===== -->
  <div class="custom-card p-3 mb-4">
    <div
      class="table-toolbar d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2"
    >
      <div class="search-box">
        <i class="fa fa-search"></i>
        <input type="text" placeholder="جستجوی نام دیزل ..." />
      </div>
      <div class="d-none filter-box">
        <select class="form-select dark-select">
          <option value="all">همه وضعیت‌ها</option>
          <option value="online">🟢 آنلاین</option>
          <option value="offline">🔴 آفلاین</option>
        </select>
      </div>
    </div>

    <div class="table-responsive" style="max-height: 60vh;">
      <table class="table custom-dark-table">
        <thead>
          <tr class="text-center">
            <th class="text-center">#</th>
            <th class="text-center">نام دیزل</th>
            <th class="text-center">ساعت کارکرد</th>
            <th class="text-center">وضعیت</th>
            <th class="text-center">توان ظاهری (kVA)</th>
            <th class="text-center">ولتاژ کلی (V)</th>
            <th class="text-center">جریان کلی (A)</th>
            <th class="text-center">ضریب توان</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" *ngFor="let g of tableData; let i = index" [ngClass]="'status-' + g.instantStatus">
            <td>{{ i + 1 }}</td>
            <td>{{ g.strName }}</td>
            <td>{{ g.totalRunHours | number: "1.0-2" }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusBadgeClass(g.instantStatus)">
                <span class="dot"></span>
                {{ getStatusText(g.instantStatus) }}
              </span>
            </td>
            <td>{{ g.powerApparent | number: "1.0-2" }}</td>
            <td>{{ g.iVoltageTotal | number: "1.0-2" }}</td>
            <td>{{ g.iCurrentTotal | number: "1.0-2" }}</td>
            <td>{{ g.iPowerFactor | number: "1.0-2" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ===== CHARTS ===== -->
  <div class="row g-4 mb-4">
    <div class="col-lg-6">
      <div class="custom-card p-3">
        <h3 class="fs-6 mb-3">
          <i class="fa fa-bar-chart text-info me-2"></i> مقایسه توان ظاهری
        </h3>
        <div class="chart-wrapper">
          <canvas #powerChart></canvas>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="custom-card p-3">
        <h3 class="fs-6 mb-3">
          <i class="fa fa-bar-chart text-info me-2"></i> مقایسه درصد بار
        </h3>
        <div class="chart-wrapper">
          <canvas #loadChart></canvas>
        </div>
      </div>
    </div>
  </div>
</div>
